export default __webpack_public_path__ + "assets/5268d4f82e683e545b906d4d10238815.png";